module.exports = __webpack_public_path__ + "static/img/productPartner_2_1.f119ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_2_1.png
// module id = JzfH
// module chunks = 34